import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AgeGateModal from '../common/AgeGateModal'; // Ahora importa el componente correcto

const EXCLUDED_ROUTES = ['/terms', '/privacy', '/dmca'];

const AgeGate = ({ onVisibilityChange }) => {
  const [showGate, setShowGate] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const isExcluded = EXCLUDED_ROUTES.includes(pathname);
    let shouldShow = false;

    if (!isExcluded) {
      try {
        const isVerified = localStorage.getItem('ageVerified');
        if (isVerified !== 'true') {
          shouldShow = true;
        }
      } catch (error) {
        console.error('Could not access localStorage:', error);
        shouldShow = true;
      }
    }

    setShowGate(shouldShow);
    if (onVisibilityChange) {
      onVisibilityChange(shouldShow);
    }
  }, [pathname, onVisibilityChange]);

  const handleConfirm = () => {
    try {
      localStorage.setItem('ageVerified', 'true');
    } catch (error) {
      console.error('Could not write to localStorage:', error);
    }
    setShowGate(false);
    if (onVisibilityChange) {
      onVisibilityChange(false);
    }
  };

  const handleExit = () => {
    window.location.href = 'https://www.google.com';
  };

  if (!showGate) {
    return null;
  }

  // Renderiza el modal visual y le pasa las funciones que debe ejecutar
  return <AgeGateModal onConfirm={handleConfirm} onExit={handleExit} />;
};

export default AgeGate;
